export default {
  red: '#e11313',
  grey: '#7b7b7b',
  white: '#ffffff',
  green: '#73b816',
  btnBlue:'#1890FF',
  black: '#000000',
  purple: '#374fc7',
  orange: '#F59F00',
  softRed: '#f03f3e',
  wrapGray: '#DDDDDD',
  softGrey: '#999999',
  softBlue: '#0082ad',
  newGreen: '#95c123',
  newOrange: '#FFB000',
  newRed: '#E82D2D',
  seaBlue: '#065f85',
  skyBlue: '#E3F2FF',
  hintGrey: '#C9C9C9',
  modalGrey: '#777777',
  transBlue: '#d5e9f1',
  softGreen: '#71af01',
  darkGreen: '#2B8A3E',
  softBlack: '#343434',
  aliceBlue: '#0091C1',
  dashGray : '#CEDEFF',
  pureWhite: '#f2f2f2',
  lightBlue: '#00C0FF',
  smootBlue: '#EBF6FF',
  borderGrey: '#e6e6e6',
  yellowWarn: '#eed202',
  darkBlue: '#004D67E5',
  cancelColor: '#cbcbcb',
  mediumGreen: '#8EC10A',
  deleteColor: '#d6362e',
  transparent: 'transparent',
  cancelTextColor: '#333333',
  backgroundColor: '#F4F6F9',
  limeGreen: '#95C123',
  tealBlue: '#008799',
  lightGrey: '#F4F4F4',
  lightSkyBlue: '#80B2DF',
  deepBlue: '#0A81AD',
  lightSilver: '#D9D9D9',
  najavoWhite: '#FFDDAA',
  topaz: '#FFCA7A',
  darkGrey: '#484848',
  paleBlue: '#f0f3f9',
  lemonYellow: '#F6D758',
  lightOlive: '#B6D27F',
  darkCharcoal: '#4B4B4B',
  darkSlate: '#4A4A4A',
  vividOrange: '#FF7F00',
  lightPink: '#FFDCDC',
  orangeMarker: '#FFBD5A',
  tundora: '#4D4D4D',
  actionDisabled: '#7E7E7E',
  actionGo: '#8CBC53',
  actionStop: '#D31E1E',
  pattensBlue: '#DDEAFF',
  alto: '#DCDCDC',
  pacificBlue: '#018DC2',
  badgeCompleted: '#8EBB3C',
  badgeAlongsideMV: '#F48500',
  badgeQueued: '#7E7E7E',
  orient: '#00678D',
  concrete: '#F3F3F3',
  gallery: '#EEEEEE',
  deepSeaBlue: '#00678D',
  lightAsh: '#F3F3F3',
  jadeGreen: '#007660',
}
